<template>
    <div>
        <h3>ตั้งค่าเลือกภาษีอัติโนมัติ</h3>
        <div class="row form-group">
            <div class="col-4 text-right">ภาษี (%)</div>
            <div class="col-6">
                <input class="form-control" type="number" v-model="form.percent_tax"/>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">เลือก Auto</div>
            <div class="col-6">
                <b-form-select :options="optionIsAuto" v-model="form.is_auto"></b-form-select>
            </div>
        </div>
        <div class="col text-center">
            <button type="button"
                    @click="submitData"
                    class="btn btn-success">
                <icon name="save" style="width: 25px"></icon>
                บันทึก</button>&nbsp;&nbsp;
            <button type="button"
                    @click="cancelData"
                    class="btn btn btn-outline-secondary">
                <icon name="times" style="width: 25px"></icon> ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "SettingTaxAuto",
        data(){
            return{
                optionIsAuto : [
                    {
                        value : 1,
                        text : 'เลือกภาษี Auto'
                    },
                    {
                        value : 0,
                        text : 'ไม่เลือกภาษี'
                    }
                ],
                percent_tax : 1,
                is_auto : 0,
            }
        },
        computed:{
            ...mapState({
                form : state=>{
                    return state.Driver.setting_tax
                },
            }),
        },
        methods:{
            submitData(){
                this.$emit('submit',this.form);
            },
            cancelData(){
                this.$emit('submit',false);
            }
        }
    }
</script>

<style scoped>

</style>
